import { Flex, Spin } from 'antd';
import type { FC } from 'react';

export const LoadingState: FC = () => {
  return (
    <Flex flex="1 1 0" justify="center" align="center" style={{ height: '100%', width: '100%' }}>
      <Spin size="large" />
    </Flex>
  );
};
